export default __webpack_public_path__ + "static/char-v-33-a481fed3963f9340ac9da81de4501b4c.png";